import { lookupCard } from "../../content/index.js";
import { applyCardEffects, type ApplyEffectContext } from "../cards/applyEffect.js";
import type { RunState } from "../types/index.js";
import { appendReshuffleLogIfNeeded } from "../run/log.js";

export function resumeRepeat(run: RunState): RunState {
  const repeat = run.pendingRepeat;
  if (!repeat || !run.activeCase) return run;
  const definition = lookupCard(repeat.target.cardId);
  if (!definition?.effect) return { ...run, pendingRepeat: null };
  const remaining = repeat.remaining - 1;
  const context: ApplyEffectContext = {
    run: {
      ...run,
      pendingRepeat: remaining > 0 ? { target: repeat.target, remaining } : null,
    },
    activeCase: run.activeCase,
    sourceInstanceId: repeat.target.instanceId,
  };
  const result = applyCardEffects(context, definition.effect);
  const next = { ...result.run, activeCase: result.activeCase };
  if (next.pendingChoice) return next;
  if (next.pendingRepeat) return resumeRepeat(next);
  return next;
}

export function continuePendingRepeat(run: RunState): RunState {
  return resumeRepeat(run);
}

export function withReshuffleLog(before: RunState, after: RunState, reshuffled?: boolean): RunState {
  return appendReshuffleLogIfNeeded(before, after, after.activeCase?.phase ?? 0, reshuffled);
}
